
function JobEntryLeft({
  job,
  company,
  jobTitle,
  concentration,
  responsibilites,
  image,
  years,
  handleJobDesc,
}) {
  return (
    <div className="workplaceWrapperMobile">
      <div className="workPlace">
        <div
          className="workPlaceClickableLeft"
          onClick={() => handleJobDesc(job.id)}
        >

          <div className="iconHolder">
            <div className="iconSize">
              <div className="icon">
                <img className="jobLogo" src={image} alt="one of my job logos"/>
              </div>
            </div>
          </div>

          <div className="jobHolderLeft">
            <div className="jobCompany">{company}</div>
            <div className="jobTitle">{jobTitle}</div>
            <div className="jobYears">{years}</div>
          </div>
          
        <div className="toolTipText" id="workPlaceClickableToolTip">
          click me
        </div>
        </div>
      </div>

      {/* <span className="toolTipText">click to copy</span> */}
    </div>
  );
}

export default JobEntryLeft;
